package features.auth.domain

data class User(
    val id: String,
    val name: String,
    val email: String,
    val avatar: String? = null
)
